import { parseRichTextDoc } from './parse-rich-text-doc';
import type { RichTextBlock, RichTextDoc, RichTextInline } from './types';

const inlineText = (content: RichTextInline[] | undefined): string =>
  (content ?? []).map((node) => (node.type === 'text' ? node.text : '\n')).join('');

const inlineLength = (content: RichTextInline[] | undefined): number =>
  (content ?? []).reduce((sum, node) => sum + (node.type === 'text' ? node.text.length : 0), 0);

const blockLines = (block: RichTextBlock): string[] =>
  block.type === 'bulletList' || block.type === 'orderedList'
    ? block.content.flatMap((item) => item.content.flatMap(blockLines))
    : [inlineText(block.content)];

const blockLength = (block: RichTextBlock): number =>
  block.type === 'bulletList' || block.type === 'orderedList'
    ? block.content.reduce(
        (sum, item) => sum + item.content.reduce((itemSum, child) => itemSum + blockLength(child), 0),
        0,
      )
    : inlineLength(block.content);

export const richTextPlainText = (doc: RichTextDoc): string => doc.content.flatMap(blockLines).join('\n').trim();

export const richTextCharacterCount = (doc: RichTextDoc): number =>
  doc.content.reduce((sum, block) => sum + blockLength(block), 0);

export const isBlankRichTextDoc = (doc: RichTextDoc): boolean => richTextPlainText(doc).length === 0;

export const richTextDocPayloadLength = (doc: RichTextDoc): number => JSON.stringify(doc).length;

export const richTextDocEquals = (a: RichTextDoc | null | undefined, b: RichTextDoc | null | undefined): boolean =>
  a === b || (!!a && !!b && JSON.stringify(parseRichTextDoc(a)) === JSON.stringify(parseRichTextDoc(b)));

export const plainTextToRichTextDoc = (text: string): RichTextDoc =>
  parseRichTextDoc({
    type: 'doc',
    content: text.split(/\r?\n/).map((line) => ({ type: 'paragraph', content: [{ type: 'text', text: line }] })),
  });
